<template>
  <div class="tabulka" :class="TableWidth">
    <TabulkaBackground BackgroundImage="pohar" />

    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Team ranking - {{ gameGoal }}</div>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Position</span>
            <SortButton
              row="rank"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Team name</span>
            <SortButton
              row="team.name"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="metric"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>{{ gameGoal }}</span>
          </td>
        </thead>
        <tr
          v-for="team in sortedData"
          :key="team.id"
          :class="{
            table__notImportantRow: team.team.id != myTeam.id,
            table__importantRow: team.team.id == myTeam.id,
          }"
        >
          <td class="important">
            <div
              :class="{
                table__poharFirst: team.rank == 0,
                table__poharNone: team.rank != 0,
              }"
            ></div>
            <!--<div :class="{table__sipkyUp: team.diff == 'up', table__sipkyDown: team.diff == 'down', table__sipkyNone: team.diff == 'none'}"></div>-->
            <span>{{ team.rank + 1 }}.</span>
          </td>
          <td>{{ team.team.name }}</td>
          <td class="right" v-if="isMoney(team.gameGoal)">
            {{ team.metric | numbersThousands | inCurrency }}
          </td>
          <td class="right" v-else-if="isProducts(team.gameGoal)">
            {{ team.metric | numbersThousands | inPieces }}
          </td>
          <td class="right" v-else-if="isPercents(team.gameGoal)">
            {{ team.metric | inPercent }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import TabulkaBackground from "@/components/game/table/TabulkaBackground.vue";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TeamRanking",
  mixins: [sortingLogicMixin],
  components: {
    TabulkaBackground,
    SortButton,
  },
  props: {
    TableWidth: String,
  },
  data() {
    return {
      currentSortRow: "rank",
      gameGoal: "",
    };
  },
  methods: {
    compareResults(a, b) {
      return a.metric > b.metric ? -1 : a.metric < b.metric ? 1 : 0;
    },
    isMoney(goal) {
      if (goal == "MONEY" || goal == "EARNED" || goal == "PROFIT") {
        return true;
      }
      return false;
    },
    isProducts(goal) {
      if (goal == "PRODUCTS_SOLD" || goal == "POPULAR_PRODUCT") {
        return true;
      }
      return false;
    },
    isPercents(goal) {
      if (goal == "MARKET_SHARE") {
        return true;
      }
      return false;
    },
    setGameGoal(goal) {
      let goalNamePre = goal.toLowerCase().trim();
      let goalNameSpace = goalNamePre.replace("_", " ");
      let goalName =
        goalNameSpace.charAt(0).toUpperCase() + goalNameSpace.slice(1);
      this.gameGoal = goalName;
    },
  },
  computed: {
    ...mapGetters({
      teamRanking: "teamRanking",
      myTeam: "myTeam",
    }),
    sourceData() {
      let sourceData = this.teamRanking
        .slice()
        .sort(this.compareResults)
        .map((team, rank) => ({ ...team, rank }));
      if (sourceData.length > 0) {
        this.setGameGoal(sourceData[0].gameGoal);
      }
      return sourceData;
    },
  },
};
</script>

